import { FormInstance } from "antd";
import { QuestionProps } from "../Question";


/**
 * The function `initializeFormValues` populates a form with initial values based on a set of
 * questions.
 * @param {QuestionProps[]} questions - The `questions` parameter is an array of objects with the
 * following structure:
 * @param form - The `form` parameter in the `initializeFormValues` function is of type
 * `FormInstance<any>`. This parameter represents a form instance that is used to manage form values
 * and validation in Ant Design forms. You can use methods provided by `FormInstance` to interact with
 * the form, such as
 */
export const initializeFormValues = (
    questions: QuestionProps[],
    form: FormInstance<any>
): void => {
    const values: Record<string, any> = {};

    questions.forEach((question) => {
        const key = question.index;

        if (!key) return;

        if (question.type === "multiQuestion") {
            question.answer?.forEach((repeatGroup: any[], repeatIndex: number) => {
                repeatGroup?.forEach((subAnswer, subIndex) => {
                    const subKey = `${key}_${repeatIndex}_${subIndex}`;
                    values[subKey] = subAnswer;
                });
            });
        } else if (Array.isArray(question.answer) && question.type !== "multiSelect") {
            values[key] = question.answer[0];
        } else {
            values[key] = question.answer;
        }
    });

    form.setFieldsValue(values);
};